export type UIElementType =
  | 'tab'
  | 'subtab'
  | 'page'
  | 'button'
  | 'filter'
  | 'field'
  | 'column'
  | 'action';

export interface UIElementDef {
  key: string;
  type: UIElementType;
  module: string;
  page?: string;
  label: string;
  description?: string;
}

const registry = new Map<string, UIElementDef>();

export function registerUIElement(def: UIElementDef): void {
  if (registry.has(def.key)) return;
  registry.set(def.key, def);
}

export function getUIElementRegistry(): UIElementDef[] {
  return [...registry.values()].sort((a, b) => a.key.localeCompare(b.key));
}
